import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import { logger } from 'logging-utils';
import {
  IssueDrawerHeaderInput,
  IssueDrawerTabsHeader,
} from '../../types/issues-types';
import query from './get-issue-drawer-tabs.gql';
import { Nullable } from '../../../../../../../utilities/ox-common-types/src/typescript-types';
import { ApolloClientCache } from 'ox-common-types';

const getIssueDrawerTabsHeaders = (
  client: ApolloClient<NormalizedCacheObject>,
) => {
  return {
    execute: async (
      input: IssueDrawerHeaderInput,
    ): Promise<Nullable<IssueDrawerTabsHeader[]>> => {
      try {
        const results = await client.query<IssueDrawerHeaderResponse>({
          query,
          variables: { input },
          fetchPolicy: ApolloClientCache.NoCache,
        });
        if (results?.data) return results.data.getIssueDrawerHeaders;
      } catch (e) {
        logger.error('Failed to get issue drawer tabs', e);
      }
      return null;
    },
  };
};

interface IssueDrawerHeaderResponse {
  getIssueDrawerHeaders: Nullable<IssueDrawerTabsHeader[]>;
}

export default getIssueDrawerTabsHeaders;
